var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h3',[_vm._v("Permissions")]),_vm._t("default"),(_vm.requestManager.requestStates.loadRole === 'pending')?_c('LoadingIcon'):_c('PermissionsForm',{attrs:{"authorities":_vm.authorities,"value":_vm.permissions},on:{"permission-change":function($event){return _vm.onPermissionsChange($event)}}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }